import { Skeleton } from "@/components/ui/skeleton";

const QuizHistoryPreviewSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          className="bg-gray-200"
          style={{ height: "76px" }}
        />
      ))}
    </div>
  );
};

export default QuizHistoryPreviewSkeleton;
